import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full max-w-xl mx-auto" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-full border border-background-300 bg-background-50 px-5 py-4 text-left transition-colors hover:border-primary-300 cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-3 text-sm font-semibold text-foreground-800">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
            <i className="ri-grid-line text-lg"></i>
          </span>
          {t("dropdown.placeholder")}
        </span>
        <span className="w-6 h-6 flex items-center justify-center text-foreground-500">
          <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`}></i>
        </span>
      </button>

      {open && (
        <ul
          className="absolute left-0 right-0 top-full mt-2 max-h-80 overflow-y-auto rounded-2xl border border-background-200 bg-background-50 p-2 z-50"
          role="listbox"
        >
          {categories.map((cat) => (
            <li key={cat.id}>
              <a
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
                role="option"
              >
                <span className="w-6 h-6 flex items-center justify-center text-accent-500">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                {t(cat.nameKey)}
                <span className="ml-auto w-4 h-4 flex items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}